"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var wishlist_exports = {};
__export(wishlist_exports, {
  Wishlist: () => Wishlist
});
module.exports = __toCommonJS(wishlist_exports);
var Wishlist;
((Wishlist2) => {
  let Add;
  ((Add2) => {
    Add2.path = "wishlist/add";
  })(Add = Wishlist2.Add || (Wishlist2.Add = {}));
  let Remove;
  ((Remove2) => {
    Remove2.path = "wishlist/remove";
  })(Remove = Wishlist2.Remove || (Wishlist2.Remove = {}));
  let Flush;
  ((Flush2) => {
    Flush2.path = "wishlist/flush";
  })(Flush = Wishlist2.Flush || (Wishlist2.Flush = {}));
  let MoveFromBasket;
  ((MoveFromBasket2) => {
    MoveFromBasket2.path = "wishlist/moveFromBasket";
  })(MoveFromBasket = Wishlist2.MoveFromBasket || (Wishlist2.MoveFromBasket = {}));
  let Share;
  ((Share2) => {
    Share2.path = "wishlist/share";
  })(Share = Wishlist2.Share || (Wishlist2.Share = {}));
})(Wishlist || (Wishlist = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Wishlist
});
